import { createAction, props } from '@ngrx/store';
import { User } from '../../../models/user';
import { HttpErrorResponse } from '@angular/common/http';

export const getStudyResearchers = createAction(
  '[StudyResearchers] Get Study Researchers',
  props<{ researchers: User[] }>()
);

export const getStudyResearchersSuccess = createAction(
  '[StudyResearchers] Get Study Researchers Success',
  props<{ researchers: User[] }>()
);

export const getStudyResearcher = createAction('[StudyResearchers] Get Study Researcher', props<{ email: string }>());

export const getStudyResearcherSuccess = createAction(
  '[StudyResearchers] Get Study Researcher Success',
  props<{ email: string; researcher: User; studyTypes: string[] }>()
);

export const getStudyResearcherError = createAction(
  '[StudyResearchers] Get Study Researcher Error',
  props<{ error: HttpErrorResponse }>()
);

export const getStudyResearcherByEmailSuccess = createAction(
  '[StudyResearchers] Get Study Researcher By Email Success',
  props<{ researcher: User }>()
);

export const setSelectedStudyResearcher = createAction(
  '[StudyResearchers] Set Selected Study Researcher',
  props<{ selectedResearcher: User }>()
);

export const addStudyResearcher = createAction(
  '[StudyResearchers] Add Study Researcher',
  props<{ studyId: number; researcher: User }>()
);

export const addStudyResearcherSuccess = createAction(
  '[StudyResearchers] Add Study Researcher Success',
  props<{ newStudyResearcher: User }>()
);

export const addStudyResearcherError = createAction(
  '[StudyResearchers] Add Study Researcher Error',
  props<{ error: HttpErrorResponse }>()
);

export const updateStudyResearcher = createAction(
  '[StudyResearchers] Update Study Researcher',
  props<{ studyId: number; researcher: User; addExisting: boolean }>()
);

export const updateStudyResearcherSuccess = createAction(
  '[StudyResearchers] Update Study Researcher Success',
  props<{ updatedStudyResearcher: User }>()
);

export const updateStudyResearcherError = createAction(
  '[StudyResearchers] Update Study Researcher Error',
  props<{ error: HttpErrorResponse }>()
);

export const deleteStudyResearcher = createAction(
  '[StudyResearchers] Delete Study Researcher',
  props<{ studyId: number; researcherId: number }>()
);

export const deleteStudyResearcherSuccess = createAction(
  '[StudyResearchers] Delete Study Researcher Success',
  props<{ deletedStudyResearcherId: number }>()
);

export const deleteStudyResearcherError = createAction(
  '[StudyResearchers] Delete Study Researcher Error',
  props<{ error: HttpErrorResponse }>()
);

export const setSingleStudyResearcherPageVisibility = createAction(
  '[StudyResearchers] Set Single Study Researcher Visibility',
  props<{ singleResearcherVisible: boolean }>()
);

export const setPrivilegesOpened = createAction(
  '[StudyResearchers] Set Privileges Opened',
  props<{ privilegesOpened: boolean }>()
);

export const noopAction = createAction('[StudyResearchers] No Operations Action');
